module.exports = __webpack_public_path__ + "static/media/playbook-mobiles.de9590b3.jpg";